export default __webpack_public_path__ + "static/media/akm.06d5aa00.svg";